import { PaginationRequest } from '@repo/ui/data-table'

import { EnrollmentAccountingFilters } from '../../lib/types/models/enrollment/enrollment-accounting-filters'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API } from '../apis.config'
import { restApiClient } from '../rest-api-client'

type GetEnrollmentAccountingPaymentsInfoResponse = {
  totalPropositionPricesAfterDiscount: number
  totalAmountReceived: number
  totalAmountToCollect: number
  totalOverpaymentToRefund: number
}

export function getEnrollmentAccountingPaymentsInfo(
  input: PaginationRequest<EnrollmentAccountingFilters> = {}
) {
  return restApiClient
    .url(
      encodeNestedObject(
        API['enrollment-accountings'].getEnrollmentAccountingPaymentsInfo.url,
        input
      )
    )
    .get<GetEnrollmentAccountingPaymentsInfoResponse>()
}
